export const GooglePreferredSourceBadge = ({ imageSrc }) => {
  return (
    <div className='googlePreferredSourceBadge'>
      <a
        href='https://google.com/preferences/source?q=https://www.houseandgarden.co.za/'
        rel='nofollow noreferrer'
        target='_blank'
      >
        <img
          alt='Add House and Garden as a preferred source on Google'
          decoding='async'
          src={imageSrc}
        />
      </a>
    </div>
  )
}
